// extracted by mini-css-extract-plugin
export var container = "header1-module--container--4c2Ze";
export var title = "header1-module--title--7dTSY";
export var subtitle = "header1-module--subtitle--9dAlX";
export var intro = "header1-module--intro--RV3Hx";